import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import CollapsibleWrapper, { Panel } from '../../../components/wrappers/CollapsibleWrapper';
import FormFields from '../../../themes/admin/Fields/FormFields';
import useSystemSwitchData from '../../../utilities/useSystemSwitchData';
import { useInventory } from './InventoryContext';

const InventoryMainDetailsSection = ({
    offset,
    isShowActive = true,
    disabled = false,
}: {
    isShowActive?: boolean;
    offset?: string;
    disabled?: boolean;
}) => {
    const { t } = useTranslation(['inventoryDetails', 'common']);
    const { yesNoSwitch } = useSystemSwitchData();

    const inventory = useInventory();

    return (
        <CollapsibleWrapper defaultActiveKey={t('inventoryDetails:sections.mainDetails')}>
            <Panel key={t('inventoryDetails:sections.mainDetails')} header={t('inventoryDetails:sections.mainDetails')}>
                <Row gutter={14}>
                    <Col lg={8} xs={24}>
                        <FormFields.InputField
                            {...t('inventoryDetails:fields.module', { returnObjects: true })}
                            name="moduleName"
                            disabled
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.InputField
                            {...t('inventoryDetails:fields.dealer', { returnObjects: true })}
                            name="dealerName"
                            disabled
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.InputField
                            {...t('inventoryDetails:fields.model', { returnObjects: true })}
                            name="modelName"
                            disabled
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.InputField
                            {...t('inventoryDetails:fields.submodel', { returnObjects: true })}
                            name="subModelName"
                            disabled
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.InputField
                            {...t('inventoryDetails:fields.variant', { returnObjects: true })}
                            name="variantName"
                            disabled
                        />
                    </Col>
                    {inventory.__typename === 'ConfiguratorInventory' && (
                        <>
                            <Col lg={8} xs={24}>
                                <FormFields.TranslatedInputField
                                    {...t('inventoryDetails:fields.color', { returnObjects: true })}
                                    name="colorSetting.name"
                                    disabled
                                />
                            </Col>
                            <Col lg={8} xs={24}>
                                <FormFields.TranslatedInputField
                                    {...t('inventoryDetails:fields.trim', { returnObjects: true })}
                                    name="trimSetting.name"
                                    disabled
                                />
                            </Col>
                            <Col lg={8} xs={24}>
                                <FormFields.TranslatedInputField
                                    {...t('inventoryDetails:fields.package', { returnObjects: true })}
                                    name="packageSetting.packageName"
                                    disabled
                                />
                            </Col>
                        </>
                    )}
                    {isShowActive && (
                        <>
                            <Col lg={8} xs={24}>
                                <FormFields.SwitchField
                                    {...yesNoSwitch}
                                    {...t('inventoryDetails:fields.isActive', { returnObjects: true })}
                                    disabled={disabled}
                                    name="isActive"
                                />
                            </Col>
                            {inventory.__typename === 'MobilityInventory' && (
                                <Col lg={8} xs={24}>
                                    <FormFields.RangePickerField
                                        {...t('inventoryDetails:fields.period', { returnObjects: true })}
                                        disabled={disabled}
                                        name="period"
                                    />
                                </Col>
                            )}
                            <Col lg={8} xs={24}>
                                <FormFields.InputField
                                    {...t('inventoryDetails:fields.lastModified', { returnObjects: true, offset })}
                                    name="lastModified"
                                    disabled
                                />
                            </Col>
                        </>
                    )}
                </Row>
            </Panel>
        </CollapsibleWrapper>
    );
};

export default InventoryMainDetailsSection;
